/**
 * Created by jamin on 07.09.17
 */

Box.Application.addModule('sv-sharing', function(context) {

    var _self = context;

    // retrieve a reference to jQuery
    var $ = context.getGlobal('jQuery');

    var _prepareSharing = function() {
        _self.$element = $(context.getElement());
    };

    var _scrollBottom = function() {

        $(window).on("scroll", function() {
            var scrollHeight = $(document).height();
            var scrollPosition = $(window).height() + $(window).scrollTop();

            if (scrollHeight - scrollPosition <= 300) {
                _self.$element.addClass('sv-locked');
            } else {
                _self.$element.removeClass('sv-locked');
            }
        });

    };

    var _detectMq = function () {
        var isMobile = window.matchMedia("only screen and (max-width: 768px)");
        if (isMobile.matches) {
            if($('.sv-cta').length) {
                _self.$element.detach().appendTo('.sv-cta');
            } else {
                _self.$element.detach().appendTo('.sv-gallery');
            }
        }
    };


    return {

        init: function() {
            _prepareSharing();
            _scrollBottom();
            _detectMq();
            window.addEventListener('resize', _detectMq, false);
        }

    };
});



// WEBPACK FOOTER //
// ./sv_cms/static/assets/js/modules/sv-sharing.js